<template>
  <div class="bottom-nav">
    <router-link
      v-if="currentRole === 'individual'"
      to="/package"
      class="bottom-nav-item"
      :class="{ active: selectedMenu === 'Package' }"
    >
      <i class="bi bi-box"></i>
      <span>{{ $t('bottomNav.home') }}</span>
    </router-link>
    <router-link
      to="/transactions"
      class="bottom-nav-item"
      :class="{ active: selectedMenu === 'Transactions' }"
    >
      <i class="bi bi-wallet"></i>
      <span>{{ $t('bottomNav.transaction') }}</span>
    </router-link>
    <router-link
      to="/profile"
      class="bottom-nav-item"
      :class="{ active: selectedMenu === 'Profile' }"
    >
      <i class="bi bi-person"></i>
      <span>{{ $t('bottomNav.profile') }}</span>
    </router-link>
    <a
      href="https://wa.me/+628122082122"
      class="bottom-nav-item"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i class="bi bi-whatsapp"></i>
      <span>{{ $t('bottomNav.callCenter') }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'BottomNav',
  computed: {
    selectedMenu() {
      return this.$store.getters.whatMenu
    },
    currentRole() {
      return this.$store.getters.getRole
    }
  }
}
</script>

<style scoped>
</style>
